import React, { useEffect } from "react";
import "./styles.css";

const Notice = ({ data }) => {
  useEffect(() => {
    //window.scrollTo(0, 0);
  }, []);

  return (
    <div className={`noticeK ${data.type}`}>
      {data.type === "error" ? (
        <i className="fa fa-times-circle fa-lg" />
      ) : data.type === "success" ? (
        <i className="fa fa-check-circle fa-lg" />
      ) : data.type === "notice" ? (
        <i className="fa fa-exclamation-circle fa-lg" />
      ) : (
        <i className="fa fa-circle-o-notch fa-spin fa-lg" />
      )}
      <span>{data.text}</span>
    </div>
  );
};

export default Notice;
